import { Typography, Layout, Button } from "antd";
import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import { auth } from "../firebase";
import TableComponent from "./Table";
import QR from "./QR";

const { Header, Content, Footer } = Layout;

const Navbar = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((u) => {
      setUser(u);
    });

    return () => unsubscribe(); // cleanup
  }, []);

  const handleGoogleSignIn = async () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    await auth.signInWithPopup(provider);
  };

  const handleLogout = () => {
    firebase.auth().signOut();
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={{ height: "auto", padding: "10px" }}>
        {user ? (
          <Button danger block onClick={handleLogout}>
            Logout
          </Button>
        ) : (
          <Button type="primary" block onClick={handleGoogleSignIn}>
            Sign in with Google
          </Button>
        )}
      </Header>

      <Content style={{ padding: "10px" }}>
        <Typography.Title level={4} style={{ textAlign: "center" }}>
          CET Cutoff
        </Typography.Title>
        <Typography.Paragraph level={1} style={{ textAlign: "center" }}>
          3rd Round 2025 - General Region <br />( Latest data for 2026 batch )
        </Typography.Paragraph>

        <TableComponent />
        <QR />
      </Content>

      <Footer style={{ textAlign: "center" }}>Made with ❤️ in Bengaluru</Footer>
    </Layout>
  );
};

export default Navbar;
